<div class="d-flex justify-content-between align-items-center mb-2">
    <h3 class="mb-0">Form Categories</h3>
    <button mat-flat-button color="primary" (click)="openDialog()">Create Category</button>
</div>

<p class="text-muted small">
    Categories group forms and scope defects. System categories are built in &mdash; their
    settings can be edited but they cannot be renamed or deleted.
</p>

<table mat-table [dataSource]="categories" class="w-100">
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let category">{{ category.name }}</td>
    </ng-container>

    <ng-container matColumnDef="kind">
        <th mat-header-cell *matHeaderCellDef>Kind</th>
        <td mat-cell *matCellDef="let category">{{ category.kind === 'pre_work' ? 'Pre-work' : 'Work' }}</td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell class="hide-on-mobile" *matHeaderCellDef>Type</th>
        <td mat-cell class="hide-on-mobile" *matCellDef="let category">
            <span class="badge rounded-pill" [class.bg-secondary]="category.is_system" [class.bg-primary]="!category.is_system">
                {{ category.is_system ? 'System' : 'Custom' }}
            </span>
        </td>
    </ng-container>

    <ng-container matColumnDef="sort_order">
        <th mat-header-cell class="hide-on-mobile" *matHeaderCellDef>Order</th>
        <td mat-cell class="hide-on-mobile" *matCellDef="let category">{{ category.sort_order }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let category">
            <button mat-button (click)="openDialog(category)">
                {{ category.is_system ? 'Edit Settings' : 'Edit' }}
            </button>
            @if (!category.is_system) {
                <button mat-button color="warn" (click)="confirmDelete(category)">Delete</button>
            }
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" style="text-align: center;" colspan="5">
            {{ isLoading ? 'Loading...' : 'No categories found.' }}
        </td>
    </tr>
</table>
